package org.multiplatform.kotfolio.pages.compose.side_effect

import androidx.compose.runtime.Composable
import org.multiplatform.kotfolio.components.KotlinCode
import org.multiplatform.kotfolio.layout.BlogLayout
import org.multiplatform.kotfolio.layout.BlogProperties
import org.multiplatform.kotfolio.layout.PageProperties
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.em
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Ol
import org.jetbrains.compose.web.dom.Ul

@Page("/compose/side_effect/launched_effect")
@Composable
fun LaunchedEffectPage() {
    BlogLayout(
        PageProperties(
            "LaunchedEffect",
            "" ),
        BlogProperties("Jetpack Compose", "LaunchedEffect"))
    {
        Column(
            horizontalAlignment = Alignment.Start
        ) {
            SpanText(
                text = "LaunchedEffect - (For One-Time Actions with State - Managing Coroutines in Composables - Running Suspend Functions - one time operations or operations triggered by changes key, getString())",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Handle asynchronous operations: Asynchronous operations in Jetpack Compose can be handled using coroutines and the suspend function. You can launch coroutines in the LaunchedEffect composable function or other coroutine builders. This allows developer to perform asynchronous task in the main thread and update the UI when the task completes.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "LaunchedEffect is a composable function that is used to launch a coroutine inside the scope of composable, when LaunchedEffect enters the composition, it launches a coroutine and cancels when it leaves composition.  It’s lifecycle-aware, which means the coroutine will automatically cancel when the composable leaves the composition.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "It triggers when a composition first starts and can execute suspend functions.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "LaunchedEffect allows you to call suspend functions safely within a composable. (The launched effect launches suspending functions inside of the composable UI. LaunchedEffect is designed to run suspend functions within the scope of a composable.)",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "It triggers a coroutine when the composable enters the composition, making it ideal for tasks like fetching data or handling side-effects based on changes in state. This makes LaunchedEffect particularly useful for one-time events or tasks that should happen in response to a change in state but need to be tied to the lifecycle of a specific composable.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "If the recomposition happens or the launched effect restarts, the existing coroutine scope will exit, and a new coroutine scope will launch.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "It is typically used for performing asynchronous operations or triggering one-time / first, launched or relaunched, or when the key parameter has changed.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "LaunchedEffect launches the coroutine as soon as the composition starts or is launched and is cleaned up when the composition exits automatically.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "In the coroutineScope block you can pass any suspended or non-suspended function.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Block is pretty straightforward — it the lambda which runs inside the coroutine scope tied to this composable. The LaunchedEffect block is executed when any of the specified key dependencies change. This ensures that the side effect code is triggered at the right moment within the lifecycle of the composable. coroutineScope block you can pass any suspended or non-suspended function.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Ul {
                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "For showing SnackBar, For re-setting UiStates, For Navigation Events, Starting Animations/Some one-time events",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Consider a scenario where LaunchedEffect is employed to update UI colors based on changes in a selected image URL. When the URL changes, the side effect code is executed to fetch and apply dominant colors.",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Let us say we want to start a timer as soon as the composable enters composition and stop it when it leaves composition, even if the timer has not ended. For this use case, we can start a timer inside the LaunchedEffect block and not worry about stopping or cleaning up timer-related code when the composable leaves composition.",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }

                    Ol {
                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "1. scrollToItem(), which was previously a function for scrolling in LazyColumn, is a suspend function.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Since compose should operate separately so as not to interfere with scrolling rendering, it is a suspend function and is forced to be called in the coroutine scope.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Smoothly transition values over time.",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Manage one-time navigation or UI events.",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Updating a Database.",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Collecting from a Flow.",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Starting an animation that should stop when the screen disappears.",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Any asynchronous operation tied to composable lifecycle",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Fetching data from a network or database when a particular state changes.",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Showing a one-time toast message when the UI is first composed.",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }
                }

                Ul {
                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "key",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                                .fontWeight(FontWeight.Bold)
                        )
                    }

                    Ul {
                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "LaunchedEffect is a Composable function that takes a key and a lambda as parameters. The lambda is executed asynchronously in a coroutine scope when the key changes.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "If you want to run the LaunchEffect block again then you have to pass any state (mutableStateOf , StateFlow) which is changing over a time in the key parameter.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "In key parameter you can pass any state because it’s a type of Any.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "key1 is a parameter which tells LaunchedEffect to relaunch the coroutine and cancel the current one whenever its value changes. Here we have passed Unit to avoid re-launching the coroutine based on this value.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Keys are dependencies that trigger the recomposition of the LaunchedEffect when they change. These keys are crucial for tying the execution of side effects to specific changes in state.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Ul {
                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "LaunchedEffect(true)",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }

                    Ul {
                        Li {
                            SpanText(
                                text = "Even though there are valid use cases for it, always pause and make sure that’s what you need.",
                                modifier = Modifier.padding(bottom = 0.3.em)
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Ul {
                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "LaunchedEffect(Unit)",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }

                    Ul {
                        Li {
                            SpanText(
                                text = "We have passed Unit to avoid re-launching the coroutine based on this value.",
                                modifier = Modifier.padding(bottom = 0.3.em)
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }
            }

            //https://github.com/nana-adrien/Portfolio.git
            KotlinCode(
                code = """
                     //Type writer Text
                     
                    @Composable
                    fun TypeWriterText(
                        text: String,
                        style: androidx.compose.ui.text.TextStyle = LocalTextStyle.current,
                        textAnimateColor: Color = MaterialTheme.colorScheme.primary,
                        additionalTexts: List<String> = listOf(),
                    ) {

                        var textIndex by remember { mutableStateOf(0) }
                        var charIndex by remember { mutableStateOf(0) }
                        var deleting by remember { mutableStateOf(false) }

                        val currentText = additionalTexts[textIndex]

                        LaunchedEffect(charIndex, deleting, textIndex) {

                            delay(if (deleting) 40 else 80)

                            if (!deleting) {
                                if (charIndex < currentText.length) {
                                    charIndex++
                                } else {
                                    delay(1200)
                                    deleting = true
                                }
                            } else {
                                if (charIndex > 0) {
                                    charIndex--
                                } else {
                                    deleting = false
                                    textIndex = (textIndex + 1) % additionalTexts.size
                                }
                            }
                        }

                        Row {
                            Text(
                                text = text,
                                style = style
                            )
                            Text(
                                currentText.substring(0, charIndex),
                                style = style.copy(fontWeight = FontWeight.Bold),
                                color = textAnimateColor,
                            )
                            BlinkingCursor(style = style, cursorColor = textAnimateColor)
                        }
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    //Type writer Text
                    
                    @Composable
                    fun TypewriterText(
                        text: String,
                        modifier: Modifier = Modifier,
                        style: TextStyle = LocalTextStyle.current,
                        typingSpeed: Long = 100, // Delay between each char (ms)
                        delayBeforeRepeat: Long = 2000 // Delay after finishing before restarting (ms)
                    ) {
                        // State to hold the text currently being displayed
                        var textToDisplay by remember { mutableStateOf("") }

                        LaunchedEffect(text) {
                            // Loop forever
                            while (true) {
                                // 1. Reset text
                                textToDisplay = ""

                                // 2. Type out characters one by one
                                text.forEachIndexed { index, _ ->
                                    textToDisplay = text.substring(startIndex = 0, endIndex = index + 1)
                                    delay(typingSpeed)
                                }

                                // 3. Wait a bit after finishing the word
                                delay(delayBeforeRepeat)
                            }
                        }

                        Text(
                            text = textToDisplay,
                            fontSize = 22.sp,
                            color = Color.White.copy(0.5f),
                            fontWeight = FontWeight.Normal,
                            style = TextStyle(
                                platformStyle = PlatformTextStyle(includeFontPadding = false)
                            )
                        )
                    }
                    """.trimIndent()
            )

            //https://github.com/ahmadsufyan455/subscription-manager.git
            KotlinCode(
                code = """
                    @OptIn(ExperimentalMaterial3Api::class)
                    @Composable
                    fun DatePickerField(
                        selectedDate: Long,
                        onDateSelected: (Long) -> Unit,
                        label: String,
                        modifier: Modifier = Modifier,
                        dateFormat: String = "MMM dd, yyyy"
                    ) {
                        var showDatePicker by remember { mutableStateOf(false) }
                        val datePickerState = rememberDatePickerState(initialSelectedDateMillis = selectedDate)
                        val interactionSource = remember { MutableInteractionSource() }

                        LaunchedEffect(interactionSource) {
                            interactionSource.interactions.collect { interaction ->
                                if (interaction is PressInteraction.Release) {
                                    showDatePicker = true
                                }
                            }
                        }

                        if (showDatePicker) {
                            DatePickerDialog(
                                onDismissRequest = { showDatePicker = false },
                                confirmButton = {
                                    TextButton(onClick = {
                                        datePickerState.selectedDateMillis?.let {
                                            onDateSelected(it)
                                        }
                                    }) {
                                        Text("OK")
                                    }
                                },
                                dismissButton = {
                                    TextButton(onClick = { showDatePicker = false }) {
                                        Text("Cancel")
                                    }
                                },
                                colors = DatePickerDefaults.colors(
                                    containerColor = MaterialTheme.colorScheme.surface
                                )
                            ) {
                                DatePicker(
                                    state = datePickerState,
                                )
                            }
                        }
                    }
                    
                    //DateFormat
                    //SimpleDateFormat(dateFormat, Locale.getDefault()).format(Date(selectedDate))
                    """.trimIndent()
            )

            KotlinCode(
                code = $$"""
                    @Composable
                    fun Counter() {
                        //The count variable is a state (mutableStateOf), and any change to its value triggers recomposition of all composables that read or depend on this state.
                        var count = remember { mutableStateOf(value = 0) }

                        var key = count.value % 3 == 0 // Key is updated

                        // LaunchedEffect is called when the key is updated
                        //The Compose runtime tracks that count.value is used in the Counter() function, so it schedules this function for recomposition.
                        LaunchedEffect(key1 = key) {
                            Log.d(tag = "Counter", msg = "Current count: ${count.value}")
                        }

                        // We increment the count which will trigger the recomposition
                        //When you increment count.value by clicking the button, the state changes.
                        Button(onClick = { count.value++ }) {
                            Text(text = "Increment count")
                        }
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    @Composable
                    fun BreathAnimation(modifier: Modifier) {
                        var isStarted by remember { mutableStateOf(4) }

                        LaunchedEffect(Unit) {
                            launch {
                                for (i in (0..3)) {
                                    delay(1600)
                                    isStarted--
                                }
                            }
                        }

                        AnimatedContent(isStarted, modifier, transitionSpec = {
                            fadeIn(tween(durationMillis = 300)) + scaleIn(tween(durationMillis = 300)) togetherWith fadeOut(
                                tween(durationMillis = 300)
                            ) + scaleOut(tween(durationMillis = 300))
                        }) {
                            if (it == 0) {
                                Text("Jetpack compose")
                            } else {
                                Text(
                                    if (it == 4) "Welcome" else it.toString(),
                                    style = if (it == 4) MaterialTheme.typography.h1.copy(fontSize = 32.sp) else MaterialTheme.typography.h1.copy(
                                        fontSize = 64.sp
                                    ),
                                    textAlign = TextAlign.Center
                                )
                            }
                        }
                    }
                    """.trimIndent()
            )

            //https://github.com/naikdp7/KMPNewsApp
            KotlinCode(
                code = """
                    //Multiple Keys

                    //Search
                    @Composable
                    fun FilteredList(category: String, sortOrder: SortOrder) {
                        // This effect runs when either category or sortOrder changes
                        LaunchedEffect(category, sortOrder) {
                            // Load data with new filters
                            viewModel.loadFilteredItems(category, sortOrder)
                        }

                        // Filtered list UI
                    }

                    //Scroll Position Save
                    //ViewModel
                    var lazyRowScrollIndex by mutableStateOf(0)
                    var lazyRowScrollOffset by mutableStateOf(0)

                    fun saveScrollPosition(state: LazyListState) {
                        lazyRowScrollIndex = state.firstVisibleItemIndex
                        lazyRowScrollOffset = state.firstVisibleItemScrollOffset
                    }

                    fun getScrollState(): LazyListState {
                        return LazyListState(
                            firstVisibleItemIndex = lazyRowScrollIndex,
                            firstVisibleItemScrollOffset = lazyRowScrollOffset
                        )
                    }

                    //UI
                    val listState = remember {
                        viewModel.getScrollState()
                    }

                    // Save scroll state when user scrolls
                    LaunchedEffect(listState.firstVisibleItemIndex, listState.firstVisibleItemScrollOffset) {
                        viewModel.saveScrollPosition(listState)
                    }

                    LazyRow(state = listState) { }
                    """.trimIndent()
            )

            KotlinCode(
                code = $$"""
                    //Animation

                    @Composable
                    fun AnimatedCounter(count: Int) {
                        var displayedCount by remember { mutableStateOf(count) }

                        // Animate the count change
                        LaunchedEffect(count) {
                            // If the count changed, animate to the new value
                            if (count != displayedCount) {
                                val start = displayedCount
                                val end = count

                                // Smooth animation over 500ms
                                (0..100).forEach { step ->
                                    val fraction = step / 100f
                                    displayedCount = lerp(start, end, fraction)
                                    delay(5) // Total animation takes ~500ms
                                }

                                // Ensure exact final value
                                displayedCount = count
                            }
                        }

                        Text("Count: $displayedCount")
                    }

                    // Linear interpolation helper
                    private fun lerp(start: Int, end: Int, fraction: Float): Int {
                        return start + ((end - start) * fraction).toInt()
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    @Composable
                    private fun HeaderItem() {
                        var randomSmartValue by remember { mutableIntStateOf(0) }
                        val animatedRandomSmartValue by animateIntAsState(
                            targetValue = randomSmartValue,
                            animationSpec = tween(1000)
                        )

                        LaunchedEffect(Unit){
                            randomSmartValue = randomValueWithRoundUp(roundUpValue = 50)
                        }

                        Text(
                            text = animatedRandomSmartValue,
                            style = MaterialTheme.typography.titleLarge.copy(fontWeight = FontWeight.Medium),
                            color = MaterialTheme.colorScheme.primary
                        )
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    @Composable
                    fun MyComposable(userId: String) {
                        var userData by remember { mutableState0f<UserData?>(null) }
                        LaunchedEffect (userId) {
                            userData = fetchUserData (userId)
                        }
                        userData?.let {
                            Text(text = it.name)
                        } ?: run {
                            CircularProgressIndicator()
                        }
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    @Composable
                    fun LocationScreen(context: Context) {
                        var location by remember { mutableStateOf<Location?>(null) }

                        LaunchedEffect(Unit) {
                            location = getLastKnownLocation(context)
                        }

                        location?.let {
                            Text("Current Location") //it.latitude, it.longitude
                        } ?: CircularProgressIndicator()
                    }

                    suspend fun getLastKnownLocation(context: Context): Location? {
                        return withContext(Dispatchers.IO) {
                            val fusedLocationClient = LocationServices.getFusedLocationProviderClient(context)
                            suspendCancellableCoroutine<Location?> { cont ->
                                fusedLocationClient.lastLocation.addOnSuccessListener {
                                    cont.resume(it)
                                }.addOnFailureListener {
                                    cont.resume(null)
                                }
                            }
                        }
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    //Navigation Events

                    @Composable
                    fun CheckoutScreen(viewModel: CheckoutViewModel, onNavigateToConfirmation: () -> Unit) {
                        // Collect one-time navigation events
                        LaunchedEffect(Unit) {
                            viewModel.navigationEvents.collect { event ->
                                when (event) {
                                    is NavigationEvent.NavigateToConfirmation -> {
                                        onNavigateToConfirmation()
                                    }
                                    // Handle other events...
                                }
                            }
                        }

                        // Checkout UI...
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    //Flow Collection

                    @Composable
                    fun UserActivityFeed(userId: String, viewModel: ActivityViewModel) {
                        var activities by remember { mutableStateOf<List<Activity>>(emptyList()) }

                        LaunchedEffect(userId) {
                            viewModel.getActivityUpdates(userId).collect { newActivities ->
                                activities = newActivities
                            }
                        }

                        // Render activity feed
                        LazyColumn {
                            items(activities) { activity ->
                                ActivityItem(activity)
                            }
                        }
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    //Focus Management

                    @Composable
                    fun SearchBar(focused: Boolean) {
                        val focusRequester = remember { FocusRequester() }

                        TextField(
                            // TextField properties
                            modifier = Modifier.focusRequester(focusRequester)
                        )

                        LaunchedEffect(focused) {
                            if (focused) {
                                // Request focus when the 'focused' parameter changes to true
                                focusRequester.requestFocus()
                            }
                        }
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = $$"""
                    //Detailed Cancellation Behavior

                    @Composable
                    fun DetailedCancellationExample(id: String) {
                        LaunchedEffect(id) {
                            println("Starting expensive operation for ID: $id")

                            val job = launch {
                                try {
                                    repeat(10) { i ->
                                        delay(1000)
                                        println("Processing step $i for ID: $id")
                                    }
                                } catch (e: CancellationException) {
                                    println("Inner job canceled for ID: $id")
                                    throw e // Re-throw to propagate cancellation
                                }
                            }

                            // This code will execute when the effect's coroutine is canceled:
                            // - Either through id changing
                            // - Or the composable leaving composition
                            job.invokeOnCompletion { cause ->
                                when (cause) {
                                    is CancellationException -> println("Job canceled due to new ID or leaving composition")
                                    null -> println("Job completed normally")
                                    else -> println("Job failed with error: ${cause.message}")
                                }
                            }

                            try {
                                // Wait for the inner job to complete
                                job.join()
                            } catch (e: CancellationException) {
                                println("Main effect canceled while waiting for job")
                                throw e // Re-throw to ensure proper cancellation
                            }
                        }
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = $$"""
                    //Event Collection Pattern

                    // ViewModel with events channel
                    class LoginViewModel : ViewModel() {
                        private val _events = Channel<LoginEvent>()
                        val events = _events.receiveAsFlow()

                        fun login(username: String, password: String) {
                            viewModelScope.launch {
                                try {
                                    // Perform login...
                                    _events.send(LoginEvent.Success("Login successful"))
                                } catch (e: Exception) {
                                    _events.send(LoginEvent.Error(e.message ?: "Unknown error"))
                                }
                            }
                        }

                        sealed class LoginEvent {
                            data class Success(val message: String) : LoginEvent()
                            data class Error(val message: String) : LoginEvent()
                        }
                    }


                    // Composable with LaunchedEffect to collect events
                    @Composable
                    fun LoginScreen(viewModel: LoginViewModel) {
                        val context = LocalContext.current

                        // Collect one-time events
                        LaunchedEffect(viewModel) {
                            viewModel.events.collect { event ->
                                when (event) {
                                    is LoginViewModel.LoginEvent.Success -> {
                                        Toast.makeText(context, event.message, Toast.LENGTH_SHORT).show()
                                        // Navigate to next screen
                                    }
                                    is LoginViewModel.LoginEvent.Error -> {
                                        Toast.makeText(context, "Error: ${event.message}", Toast.LENGTH_LONG).show()
                                    }
                                }
                            }
                        }

                        // Login form UI...
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = $$"""
                    //Avoiding Infinite Loops and Other Pitfalls

                    // PROBLEMATIC: Creates an infinite loop
                    @Composable
                    fun InfiniteLoopExample() {
                        var counter by remember { mutableStateOf(0) }

                        // DON'T DO THIS
                        LaunchedEffect(Unit) {
                            // This will cause recomposition, which launches another effect, and so on
                            counter++
                        }
                    }

                    // FIXED: Use a separate trigger
                    @Composable
                    fun FixedExample() {
                        var counter by remember { mutableStateOf(0) }
                        var shouldIncrement by remember { mutableStateOf(false) }

                        LaunchedEffect(shouldIncrement) {
                            if (shouldIncrement) {
                                counter++
                                shouldIncrement = false
                            }
                        }

                        Button(onClick = { shouldIncrement = true }) {
                            Text("Increment: $counter")
                        }
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    //Infinite Loop
                    @Composable
                    fun AnimatedLoadingCircle(
                        modifier: Modifier = Modifier,
                        tint: Color = Theme.colors.primary
                    ) {

                        var angle by remember { mutableFloatStateOf(0f) }

                        LaunchedEffect(Unit) {
                            while (true) { //infinite tight loop with no suspension point.
                                angle = (angle + 45f) % 360f
                                delay(100)
                            }
                        }

                        Icon(
                            modifier = modifier.rotate(degrees = angle),
                            imageVector = ImageVector.vectorResource(R.drawable.loading),
                            contentDescription = stringResource(R.string.loading),
                            tint = tint,
                        )
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = $$"""
                    //Error Handling Within LaunchedEffect

                    @Composable
                    fun RobustErrorHandlingExample(userId: String) {
                        var errorMessage by remember { mutableStateOf<String?>(null) }

                        LaunchedEffect(userId) {
                            try {
                                // Attempt potentially failing operation
                                val result = withContext(Dispatchers.IO) {
                                    userRepository.fetchUserData(userId)
                                }
                                // Process successful result
                                processData(result)
                            } catch (e: CancellationException) {
                                // Always rethrow CancellationException to maintain coroutine contract
                                throw e
                            } catch (e: IOException) {
                                // Handle network errors
                                errorMessage = "Network error: ${e.message}"
                            } catch (e: Exception) {
                                // Handle other exceptions
                                errorMessage = "Error: ${e.message}"
                                // Optional: log the error
                                Log.e("LaunchedEffect", "Error in user data fetch", e)
                            }
                        }

                        // Show error in UI if present
                        errorMessage?.let {
                            ErrorMessage(it) {
                                // Clear error when dismissed
                                errorMessage = null
                            }
                        }
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    //Moving Background
                    
                    @Composable
                    fun MovingBackgroundImage() {
                        val background = painterResource(id = R.drawable.background)
                        val configuration = LocalConfiguration.current
                        val screenWidthDp = configuration.screenWidthDp.toFloat()

                        var offsetX by remember { mutableFloatStateOf(0f) }
                        val speed = 2f

                        LaunchedEffect(Unit) {
                            while (true) {
                                awaitFrame()
                                offsetX -= speed
                                if (offsetX <= -screenWidthDp) {
                                    offsetX += screenWidthDp
                                }
                            }
                        }

                        Box(modifier = Modifier.fillMaxSize()) {
                            // First image
                            Image(
                                painter = background,
                                contentDescription = null,
                                contentScale = ContentScale.FillBounds,
                                modifier = Modifier
                                    .fillMaxHeight()
                                    .width(screenWidthDp.dp)
                                    .offset(x = offsetX.dp)
                            )

                            Image(
                                painter = background,
                                contentDescription = null,
                                contentScale = ContentScale.FillBounds,
                                modifier = Modifier
                                    .fillMaxHeight()
                                    .width(screenWidthDp.dp)
                                    .offset(x = (offsetX + screenWidthDp - 1f).dp)
                            )
                        }
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    val lifecycleOwner = LocalLifecycleOwner.current
                    val lifecycleState by lifecycleOwner.lifecycle.currentStateFlow.collectAsStateWithLifecycle()

                    LaunchedEffect(lifecycleState) {
                        // You may want to use DisposableEffect or other alternatives
                        // instead of LaunchedEffect
                        when (lifecycleState) {
                            Lifecycle.State.DESTROYED -> {}
                            Lifecycle.State.INITIALIZED -> {}
                            Lifecycle.State.CREATED -> {}
                            Lifecycle.State.STARTED -> {}
                            Lifecycle.State.RESUMED -> {}
                        }
                    }
                    """.trimIndent()
            )

            SpanText(
                text = "How LaunchedEffect Works in Compose",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Declaring a LaunchedEffect composable with one or more key parameters.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Writing coroutine code within the LaunchedEffect block.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Having the coroutine automatically canceled when the composable leaves composition or when the key changes",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Ul {
                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "LaunchedEffect automatically handles lifecycle concerns, preventing memory leaks and ensuring resources are properly cleaned up.",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }
                }
            }

            SpanText(
                text = "When Does LaunchedEffect Run?",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "LaunchedEffect starts as soon as composition is done but before rendering happens.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Ol {
                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Composable functions finish running (composition completes).",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Jetpack Compose determines the UI structure.",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Before UI is fully drawn, LaunchedEffect starts executing.",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "LaunchedEffect runs after composition but before UI is fully drawn.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Ol {
                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "It does not wait for the UI to be visible on the screen.",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "It ensures that coroutines start only after the UI structure is known, avoiding unnecessary re-runs.",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }
                }
            }

            SpanText(
                text = "LaunchedEffect Key Features",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Accepts one or multiple keys as parameters.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Restarts whenever any of the keys change.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Cancels the running coroutine if the composable is removed from the composition.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "What Not To Do",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Avoid launching long-running operations in LaunchedEffect that might block the main thread. Always ensure that the work is offloaded to a background thread.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Don't use LaunchedEffect for actions that you expect to happen repeatedly. Consider using rememberUpdatedState for state changes that don’t require side effects.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "How can we handle asynchronous operations in Jetpack Compose?",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "LaunchedEffect or rememberCoroutineScope to handle asynchronous tasks.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "LaunchedEffect: It’s used for launching suspend function when composable enters the recomposition or when key value changes. It allow as to perfrom asynchronous operation while keeping the UI responsive.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "RememberCoroutinesScope: It’s provides a coroutines scope tied to the composable’s lifecycle. It allow us to launch coroutines in responsive to UI events like button clicks.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "CollectAsState with Flow : To handle asynchronous steams of data, Flow can be used with collectAsState(), which means automatically collect and update the UI when data chnages.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "State hosting: State is passed as parameter to a composables and modified outside them for better reusability and testability.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "SideEffects For Non-Suspendable Side Effects : It is useful for non-suspendable side effects that need to executed after a recomposition.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Choosing Between LaunchedEffect and ViewModel with Flow",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Ol {
                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Opt for LaunchedEffect when your data is UI-specific and does not need to survive configuration changes or be shared with other composables.",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "It’s best used for quick, one-time side effects like fetching local data, loading preferences, or triggering animations.",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Every time a configuration change occurs (such as screen rotation), recomposition happens, causing LaunchedEffect to restart. This leads to LoadInitialData being called multiple times unnecessarily.",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }
                }

                //https://medium.com/@YodgorbekKomilo/loading-initial-data-launchedeffect-vs-viewmodel-with-flow-in-jetpack-compose-05497d89adfd
                Ol {
                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Choose ViewModel with Flow when your app needs lifecycle-aware, persistent data that can survive configuration changes.",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Ideal for complex, long-lived operations such as network requests, caching, or database interactions.",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Use it when multiple composables need to consume the same data, such as user profiles, list content, or other shared UI states.",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "Testing is problematic because we lack control over the LoadInitialData function being called during initialization. This makes it difficult to write reliable tests or trigger the function at the right moment.",
                            modifier = Modifier
                                .fontSize(FontSize.Medium)
                        )
                    }
                }
            }

            SpanText(
                text = "What’s the logic behind the key parameter?",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The key parameter in LaunchedEffect is used to identify the LaunchedEffect instance and prevent it from being recomposed unnecessarily.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "When a Composable is recomposed, Jetpack Compose determines if it needs to be redrawn. If a Composable’s state or props have changed, or if a Composable has called invalidate, Jetpack Compose will redraw the Composable. Redrawing a Composable can be an expensive operation, especially if the Composable contains long-running operations or side effects that don't need to be re-executed every time the Composable is recomposed.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "By providing a key parameter to LaunchedEffect, we can specify a value that uniquely identifies the LaunchedEffect instance. If the value of the key parameter changes, Jetpack Compose will consider the LaunchedEffect instance as a new instance, and will execute the side effect again. If the value of the key parameter remains the same, Jetpack Compose will skip the execution of the side effect and reuse the previous result, preventing unnecessary recompositions.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Key Values Remain Unchanged / It will not re-run (or \"re-trigger\")",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Stable Keys: If the values passed as keys (e.g., key1, key2) have the same value during a recomposition, the existing coroutine continues to run without interruption or restarting.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Constant Keys: Using a constant like Unit or true as a key ensures the effect runs exactly once when the composable first enters the composition and never again, regardless of how many times the parent composable recomposes.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "LaunchedEffect() - React to Navigation Arguments",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Use it when the argument is already delivered to the screen, and you need to trigger side effects (API call, loading state, analytics).",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "User opens Order Details screen, and you fetch the order from backend (when the argument arrive.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Lifecycle of LaunchedEffect",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Initial Composition: When a composable containing LaunchedEffect first enters the composition, the effect’s coroutine is launched immediately after the composition completes.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Key Changes: When any of the key parameters change, the current coroutine is canceled and a new one is launched with updated values.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Recomposition Without Key Changes: If the composable recomposes but none of the keys change, the existing coroutine continues running uninterrupted.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Leaving Composition: When the composable leaves the composition (e.g., navigating away from a screen), the coroutine is automatically canceled.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            KotlinCode(
                code = $$"""
                    @Composable
                    fun LifecycleExample(isVisible: Boolean, counter: Int) {
                        if (isVisible) {
                            // Effect only exists when isVisible is true
                            // Counter changes will restart the effect
                            LaunchedEffect(counter) {
                                println("Effect started with counter: $counter")

                                try {
                                    // Long-running task
                                    repeat(100) {
                                        delay(1000)
                                        println("Working... $it")
                                    }
                                    println("Completed normally")
                                } catch (e: CancellationException) {
                                    // Will be caught if effect is canceled due to:
                                    // - counter changing (key change)
                                    // - isVisible becoming false (leaving composition)
                                    println("Effect was canceled")
                                } finally {
                                    // Cleanup code runs on both normal completion and cancellation
                                    println("Effect cleanup")
                                }
                            }

                            Text("Counter: $counter")
                        }
                    }
                    """.trimIndent()
            )
        }
    }
}